export enum EUserType {

    None = 0,
    Standard = 1,
    Gestionnaire = 2,
    Administrateur = 3
}